export const matchAllTrailingSlashes = /(\/\/+)$/;
